import {
	CURRENCY_SCRIPS,
	EQUITY_MARKET_SEGMENTS,
	EQUITY_SCRIPS,
	FUTURES_SCRIPS,
	INDEX_SCRIPS,
	OPTIONS_SCRIPS,
} from '../../../constants/equity/orderForm/orderFormBase';

function isIndexDerivatesScrip(scripType) {
	return INDEX_SCRIPS.includes(scripType);
}

function isCurrencyDerivatesScrip(scripType) {
	return CURRENCY_SCRIPS.includes(scripType);
}

function isFutureScrip(scripType) {
	return FUTURES_SCRIPS.includes(scripType);
}

function isOptionScrip(scripType) {
	return OPTIONS_SCRIPS.includes(scripType);
}

function isEquityScrip(scripType) {
	return EQUITY_SCRIPS.includes(scripType);
}

function isFutureOptionsScrip(exchange) {
	return exchange === EQUITY_MARKET_SEGMENTS.NSE_FO;
}

function isBseExchange(exchange) {
	return exchange === EQUITY_MARKET_SEGMENTS.BSE_EQ;
}

function isCarryForwardProduct(scripType) {
	return isFutureScrip(scripType) || isOptionScrip(scripType);
}

const orderScripService = {
	isIndexDerivatesScrip,
	isCurrencyDerivatesScrip,
	isFutureScrip,
	isOptionScrip,
	isEquityScrip,
	isFutureOptionsScrip,
	isBseExchange,
	isCarryForwardProduct,
};

export default orderScripService;
